import { DialogActions } from '@mui/material';
import { EvaluationReviews } from 'lib/common/EvaluationDetails';
import CustomButton from 'lib/designSystem/Button';
import React from 'react';

const EvaluationsModule = (props: any) => {
  const { selectedRequest, setOpen } = props;
  const ImportedModuleLayout = (props: any) => {
    return (
      <div>
        {props.children}
        <DialogActions>
          <CustomButton
            onClick={() => setOpen(false)}
            color="secondary"
            style={{ marginTop: '10px' }}
          >
            Salir
          </CustomButton>
        </DialogActions>
      </div>
    );
  };
  return (
    <ImportedModuleLayout>
      <EvaluationReviews
        requestEntries={[
          { requestId: selectedRequest.id, requestType: 'confirming-request' },
        ]}
      />
    </ImportedModuleLayout>
  );
};

export default EvaluationsModule;
